module.exports = __webpack_public_path__ + "img/15_Vieja tiuque. Borde mejorado (A.pictus).5363180a.png";